
import { Button, Toast, Modal } from 'antd-mobile';
import { useRef, useState } from 'preact/hooks';
import Clipboard from 'react-clipboard.js';
import styled from 'styled-components';

import './index.css';

const Copy = ({ token, visible, close }) => {
    const ref = useRef();
    return (
        <Modal
            visible={visible}
            content={
                <Container>
                    复制本段文字{token}，打开淘宝APP领券购买
                    <Clipboard
                        style={{ background: 'white', border: '0px', marginTop: '10px' }}
                        ref={ref}
                        data-clipboard-text={token}
                    >
                        <Button onClick={() => {
                            Toast.show('复制成功');
                            close();
                        }} size='small' style={{ '--background-color': '#f76d0f', '--border-radius': '20px', '--text-color': 'white' }}>
                            一键复制
                        </Button>
                    </Clipboard>
                </Container>
            }
        >

        </Modal>
    )
}
const Container = styled.div`
    display: flex;
    flex-direction: column;
`;


export default Copy;